<template>
  <div :id="content.idHTML" :class="jel_getClassObject(content)">
    <GroupeRadio v-model="genre" :content="getContent()"></GroupeRadio>
  </div>
</template>

<script>
import GroupeRadio from '@/components/formulaire/base/GroupeRadio.vue';

export default {
  name: 'FormulaireGenre',
  components: {
    GroupeRadio,
  },

  props: { content: { type: Object, required: true } },
  computed: {
    genre: {
      get() {
        return this.$store.state.compte.genre;
      },
      set(value) {
        this.$store.commit('compte/SET_GENRE', value);
      },
    },
  },
  methods: {
    getContent() {
      // eslint-disable-next-line vue/no-mutating-props
      this.content.format = 'boutons';
      // eslint-disable-next-line vue/no-mutating-props
      this.content.type = 'texte';
      // eslint-disable-next-line vue/no-mutating-props
      this.content.largeurBouton = 'identique';
      return this.content;
    },
  },
};
</script>
